<template>
  <v-dialog v-model="dialog">
    <v-card v-if="itemVO" :loading="salvando">
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Editar Item VO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="ml-auto" type="submit" text @click="salvar(itemVO)"> Salvar </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-simple-table>
          <template #default>
            <tbody>
              <tr>
                <td>Código de Barra</td>
                <td>
                  <v-text-field v-model="itemVO.codigoBarra" type="number" />
                </td>
              </tr>

              <tr>
                <td>Descrição</td>
                <td>
                  <v-text-field v-model="itemVO.descricao" />
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <v-simple-table>
                    <template #default>
                      <thead>
                        <th class="text-left pt-3">
                          <b>NCM</b>
                        </th>
                      </thead>
                      <tbody>
                        <tr v-for="item in classificacoes" :key="item.descricao">
                          <td>{{ item.codigo }}</td>
                          <td>
                            <span>
                              {{ item.descricao }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </tr>

              <tr>
                <td>
                  <b>NESH</b>
                </td>
                <td>{{ itemVO.nesh.descricao }}</td>
              </tr>

              <tr>
                <td>
                  <b>PIS COFINS</b>
                </td>
                <td>{{ itemVO.pisCofins.descricao }}</td>
              </tr>

              <tr>
                <td>
                  <b>Natureza Receita</b>
                </td>
                <td>{{ itemVO.natureza.descricao }}</td>
              </tr>

              <tr>
                <td>
                  <b>IPI</b>
                </td>
                <td>{{ itemVO.ipi.descricao }}</td>
              </tr>

              <tr>
                <td>
                  <b>100%</b>
                </td>
                <td>
                  <p class="mb-0">{{ itemVO.conferidoIcms ? 'ICMS' : '' }}</p>
                  <p class="mb-0">{{ itemVO.conferidoPisCofins ? 'Pis Cofins' : '' }}</p>
                  <p class="mb-0">{{ itemVO.conferidoFornecedor ? 'Fornecedor' : '' }}</p>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-divider />

        <v-data-table
          :items="icmsRelacionados"
          :headers="headersRegras"
          :sort-by="['icms.uf.sigla', 'dataInicioVigencia']"
          :sort-desc="[false, true]"
          hide-default-footer
        >
          <template #[`item.dataInicioVigencia`]="{ item }">
            {{ formatDate(item.dataInicioVigencia) }}
          </template>

          <template #[`item.dataFimVigencia`]="{ item }">
            {{ formatDate(item.dataFimVigencia) }}
          </template>

          <template #[`item.actions`]="{ item }">
            <div class="d-flex flex-nowrap justify-center">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-icon v-on="on" @click="abrirDialogExcluirVigencia(item)"> mdi-delete </v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />

    <v-dialog v-model="dialogDeleteIcmsVigente" persistent max-width="380">
      <v-card>
        <v-card-title class="headline">Excluir</v-card-title>
        <v-card-text refs="cestDelete">
          Tem certeza que deseja remover a vigência do ICMS
          <b> {{ icmsVigenteDelete.icms.descricao }} </b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogDeleteIcmsVigente = false">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="removerIcmsVigente">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import ItemVO from '@/models/itemvo'
import ItensVOService from '@/services/itensVO/itensVO'
import NCMService from '@/services/ncm/ncm'
import { obrigatorio } from '@/shareds/regrasForm'
import { formatDate } from '@/shareds/formatacoes'
import SnackBar from '@/models/components/snackbar'
import SnackbarMessage from '@/components/SnackbarMessage'

export default {
  components: { SnackbarMessage },
  props: ['showDialog', 'itemParam', 'opcoes'],

  data: () => ({
    dialog: false,
    itemVO: new ItemVO(),
    icmsRelacionados: [],
    classificacoes: [],
    obrigatorio: obrigatorio,
    infos: {},
    headersRegras: [
      { text: 'UF', value: 'icms.uf.sigla', divider: true },
      { text: 'Lei', value: 'icms.lei.nome', divider: true },
      { text: 'Regra ICMS', value: 'icms.descricao', divider: true },
      { text: 'CST', value: 'icms.cst.codigo', divider: true },
      { text: '% ICMS Orig', value: 'icms.icmsOriginal', divider: true },
      { text: '% ICMS Saída', value: 'icms.icmsSaida', divider: true },
      { text: '% MVA', value: 'icms.mva', divider: true },
      { text: 'Início Vigência', value: 'dataInicioVigencia', divider: true },
      { text: 'Fim Vigência', value: 'dataFimVigencia', divider: true },
      { text: '', value: 'actions', sortable: false, width: '10' }
    ],
    salvando: false,
    dataError: '',
    showMessageError: false,
    icmsVigenteDelete: {
      dataFimVigencia: '',
      dataInicioVigencia: '',
      icms: {}
    },
    indiceIcmsVigenteDelete: '',
    dialogDeleteIcmsVigente: false,
    snackbar: new SnackBar(),
    formatDate: formatDate
  }),

  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    dialog() {
      return this.dialog ? this.buscarDados() : this.fecharDialog()
    }
  },

  methods: {
    async buscarDados() {
      this.itemVO = this.itemParam
      this.icmsRelacionados = await ItensVOService.getIcmsRelacionados(this.itemVO.id)
      this.classificacoes = await NCMService.getClassificacoesByNCM(this.itemVO.ncm.id)
    },

    async salvar(itemVO) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          id: itemVO.id,
          codigoBarra: itemVO.codigoBarra || undefined,
          descricao: itemVO.descricao
        }

        const itemVOSalvo = await ItensVOService.update(data.id, data)
        this.$emit('confirmado', itemVOSalvo)

        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    abrirDialogExcluirVigencia(item) {
      this.indiceIcmsVigenteDelete = this.icmsRelacionados.indexOf(item)
      this.icmsVigenteDelete = this.icmsRelacionados[this.indiceIcmsVigenteDelete]

      if (!this.icmsVigenteDelete.icms.id) return

      this.dialogDeleteIcmsVigente = true
    },

    async removerIcmsVigente() {
      try {
        await ItensVOService.removerIcmsVigente(this.itemVO.id, this.icmsVigenteDelete.icms.id)
        this.snackbar.snackTextParam = 'ICMS vigente removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.icmsRelacionados.splice(this.indiceIcmsVigenteDelete, 1)
        this.dialogDeleteIcmsVigente = false
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined
            ? error.message
            : error.response.data.message
            ? error.response.data.message
            : 'Não foi possível excluir o ICMS vigente.'
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
